<div 
*appLet="{culture: (culture$ | async)} as $comp"
>
  <div class="top-bar">
    <span></span>
    <p class="fs-4 lh-sm">
      @switch ($comp.culture) {
        @case ('en-US' || 'en-GB') {
          Whoa! Traveling that light?
        }
        @case ('nb-NO') {
          Whoa! Reiser du så lett?
        }
        @case ('de-DE') {
          Wow! Reist du so leicht?
        }
        @case ('fr-FR') {
          Waouh ! Vous voyagez si léger ?
        }
        @case ('it-IT') {
          Wow! Viaggi così leggero?
        }
        @default {
          Whoa! Traveling that light?
        }
      }
    </p>
    <button
      id="btnClose"
      type="button"
      class="btn-close close"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="mid-section">
    <div class="bags">
      <div class="bag">
        <div class="img-wrapper">
          <img src="/assets/img/svg/personal-item.svg" alt="personal item">
          <span appOnTap class="img-tooltip-wrapper">
            <button
                type="button"
                class="btn btn-link in-text info text-black-50"
                appOnTap
                tooltip="40 x 30 x 15 cm  (15.5 x 11.5 x 5.5 in)"
                triggers="focus"
                placement="auto"
              >
                <img src="/assets/img/svg/info.svg" alt="tooltip icon">
            </button>
          </span>
        </div>
        <p class="name">
          @switch ($comp.culture) {
            @case ('en-US' || 'en-GB') {
              Personal item
            }
            @case ('nb-NO') {
              Veske under sete
            }
            @case ('de-DE') {
              Persönlicher Gepäck
            }
            @case ('fr-FR') {
              Article personnel
            }
            @case ('it-IT') {
              Effetto personale
            }
            @default {
              Personal item
            }
          }
        </p>
        <span class="chips included">
          @switch ($comp.culture) {
            @case ('en-US' || 'en-GB') {
              Included
            }
            @case ('nb-NO') {
              Inkludert
            }
            @case ('de-DE') {
              Inklusive
            }
            @case ('fr-FR') {
              Inclus
            }
            @case ('it-IT') {
              Incluso
            }
            @default {
              Included
            }
          }
        </span>
      </div>
      <div class="bag">
        <div class="img-wrapper">
          <img src="/assets/img/svg/carry-on-bag.svg" alt="carry-on bag">
          <span appOnTap class="img-tooltip-wrapper">
            <button
                type="button"
                class="btn btn-link in-text info text-black-50"
                appOnTap
                tooltip="56 x 45 x 25 cm (22 x 18 x 10 in)"
                triggers="focus"
                placement="auto"
              >
                <img src="/assets/img/svg/info.svg" alt="tooltip icon">
            </button>
          </span>
        </div>
        <p class="name">
          @switch ($comp.culture) {
            @case ('en-US' || 'en-GB') {
              Carry-on bag
            }
            @case ('nb-NO') {
              Håndbagasje
            }
            @case ('de-DE') {
              Handgepäck
            }
            @case ('fr-FR') {
              Bagage à main
            }
            @case ('it-IT') {
              Bagaglio a mano
            }
            @default {
              Carry-on bag
            }
          }
        </p>
        <span class="chips">
          @switch ($comp.culture) {
            @case ('en-US' || 'en-GB') {
              Not included
            }
            @case ('nb-NO') {
              Ikke inkl.
            }
            @case ('de-DE') {
              Nicht inkl.
            }
            @case ('fr-FR') {
              Non inclus
            }
            @case ('it-IT') {
              Non incluso
            }
            @default {
              Not included
            }
          }
        </span>
      </div>
      <div class="bag">
        <div class="img-wrapper">
          <img src="/assets/img/svg/checked-bag.svg" alt="checked bag">
          <span appOnTap class="img-tooltip-wrapper">
            <button
                type="button"
                class="btn btn-link in-text info text-black-50"
                appOnTap
                tooltip="158 cm / 62 in (H + W + L)"
                triggers="focus"
                placement="auto"
              >
                <img src="/assets/img/svg/info.svg" alt="tooltip icon">
            </button>
          </span>
        </div>
        <p class="name">
          @switch ($comp.culture) {
            @case ('en-US' || 'en-GB') {
              Checked bag
            }
            @case ('nb-NO') {
              Innsjekket baggasje
            }
            @case ('de-DE') {
              Aufgabegepäck
            }
            @case ('fr-FR') {
              Bagage en soute
            }
            @case ('it-IT') {
              Bagaglio in stiva
            }
            @default {
              Checked bag
            }
          }
        </p>
        <span class="chips">
          @switch ($comp.culture) {
            @case ('en-US' || 'en-GB') {
              Not included
            }
            @case ('nb-NO') {
              Ikke inkl.
            }
            @case ('de-DE') {
              Nicht inkl.
            }
            @case ('fr-FR') {
              Non inclus
            }
            @case ('it-IT') {
              Non incluso
            }
            @default {
              Not included
            }
          }
        </span>
      </div>
    </div>
    <div class="information">
      <div class="warning">
        <img src="/assets/img/svg/error.svg" alt="error icon">
        <span>
          @switch ($comp.culture) {
            @case ('en-US' || 'en-GB') {
              You only have a small personal item included (max 40x30x15cm).
            }
            @case ('nb-NO') {
              Du har bare en liten veske under setet inkludert (max 40x30x15cm).
            }
            @case ('de-DE') {
              Es ist nur ein kleines persönliches Gepäckstück enthalten (max 40x30x15cm).
            }
            @case ('fr-FR') {
              Vous avez seulement un petit objet personnel inclus (max 40x30x15cm).
            }
            @case ('it-IT') {
              Hai solo un piccolo oggetto personale incluso (max 40x30x15cm).
            }
            @default {
              You only have a small personal item included (max 40x30x15cm).
            }
          }
        </span>
      </div>
      <div class="info">
        <span>
          @switch ($comp.culture) {
            @case ('en-US' || 'en-GB') {
              If you bring a second item or if your item is larger than allowed size, you will be charged a fee at the airport.
            }
            @case ('nb-NO') {
              Hvis du tar med en ekstra veske eller hvis vesken din er større enn tillatt, vil du bli belastet en avgift på flyplassen.
            }
            @case ('de-DE') {
              Wenn Sie einen zweiten Gegenstand mitbringen oder wenn Ihr Gegenstand größer als die erlaubte Größe ist, wird Ihnen am Flughafen eine Gebühr berechnet.
            }
            @case ('fr-FR') {
              Si vous apportez un deuxième article ou si votre article dépasse la taille autorisée, des frais vous seront facturés à l'aéroport.
            }
            @case ('it-IT') {
              Se porti un secondo oggetto o se il tuo oggetto è più grande della dimensione consentita, ti verrà addebitata una tariffa in aeroporto.
            }
            @default {
              If you bring a second item or if your item is larger than allowed size, you will be charged a fee at the airport.
            }
          }
        </span>
        <img src="/assets/img/svg/bag.svg" alt="bag icon">
      </div>
    </div>
    <app-message type="success no-font-resize">
      <img icon src="/assets/img/svg/thumb-up.svg" alt="thumb up">
      <p content>
        @switch ($comp.culture) {
          @case ('en-US' || 'en-GB') {
            Plan ahead and <strong>save up to 42%</strong> compared to adding bags at the airport.
          }
          @case ('nb-NO') {
            Planlegg på forhånd og <strong>spar opptil 42%</strong> sammenlignet med å legge til bagasje på flyplassen.
          }
          @case ('de-DE') {
            Planen Sie im Voraus und <strong>sparen Sie bis zu 42%</strong> im Vergleich zur Hinzufügung von Gepäck am Flughafen.
          }
          @case ('fr-FR') {
            Planifiez à l'avance et <strong>économisez jusqu'à 42%</strong> par rapport à l'ajout de bagages à l'aéroport.
          }
          @case ('it-IT') {
            Pianifica in anticipo e <strong>risparmia fino al 42%</strong> rispetto all'aggiunta di bagagli in aeroporto.
          }
          @default {
            Plan ahead and <strong>save up to 42%</strong> compared to adding bags at the airport.
          }
        }
      </p>
    </app-message>
  </div>
  <div class="buttons">
    <button
      class="btn btn-primary btn-cta full-width btn-sm"
      (click)="onCancelClick()"
      data-qa="modal-continue-button"
    >
      @switch ($comp.culture) {
        @case ('en-US' || 'en-GB') {
          Add bags and save now
        }
        @case ('nb-NO') {
          Legg til bagasje og spar nå
        }
        @case ('de-DE') {
          Füge jetzt Gepäck hinzu und spare
        }
        @case ('fr-FR') {
          Ajoutez des bagages et économisez maintenant
        }
        @case ('it-IT') {
          Aggiungi bagagli e risparmia ora
        }
        @default {
          Add bags and save now
        }
      }
    </button>
    <button
      class="btn btn-link full-width btn-sm"
      (click)="onPrimaryClick()"
      data-qa="modal-cancel-button"
    >
      @switch ($comp.culture) {
        @case ('en-US' || 'en-GB') {
          Continue without adding bags
        }
        @case ('nb-NO') {
          Fortsett uten å legge til bagasje
        }
        @case ('de-DE') {
          Fortfahren ohne Gepäck hinzuzufügen
        }
        @case ('fr-FR') {
          Continuez sans ajouter de bagages
        }
        @case ('it-IT') {
          Continua senza aggiungere bagagli
        }
        @default {
          Continue without adding bags
        }
      }
    </button>
  </div>
</div>